import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';
import { AuthorizationService } from '@app/services/authorization.service';

@Component({
    selector: 'app-user-template',
    templateUrl: './user-template.component.html',
    styleUrls: ['./user-template.component.css'],
    standalone: false
})
export class UserTemplateComponent implements OnInit {

  title = 'banking-app';
  isAdmin: boolean = false;
  isNavbarMinimized: boolean = true;

  constructor(public authenticationService: AuthenticationService,
    public authorizationService: AuthorizationService,
    private router: Router) { }

  ngOnInit(): void {
  if (this.authenticationService.isAuthenticated()) {
    this.isAdmin = this.authorizationService.isAdmin();
  } else {
    this.authenticationService.ensureSession().subscribe(isAuthenticated => {
      if (!isAuthenticated) {
        this.router.navigate(['/login']);
      } else {
        this.isAdmin = this.authorizationService.isAdmin();
      }
    });
  }
}

  toggleNavbar() {
    this.isNavbarMinimized = !this.isNavbarMinimized;
  }

}